import type { ColumnVisibilityState } from '@tanstack/react-table';

import { mergeColumnVisibility } from '@/utils/columnVisibility';

const DEFAULT_VISIBLE_COLUMNS: ColumnVisibilityState = {
    id: true,
    bioscopeStatus: true,
    client: true,
    region: true,
    location: true,
    pen: true,
    fishGroup: true,
    cageId: false,
    lastMeasurement: true,
    cabinet: false,
    bioscopeVersion: false,
    version: false,
    fishType: false,
    cageType: false,
    moved: true,
    alerts: true,
    finClip: false,
    winch: false,
    winchId: false,
    testBioscope: false,
    uvc: false,
    jetpackVersion: false,
};

export function resolveColumnVisibility(stored: ColumnVisibilityState): ColumnVisibilityState {
    return mergeColumnVisibility(DEFAULT_VISIBLE_COLUMNS, stored);
}

export const COLUMN_VISIBILITY_STORAGE_KEY = 'bioscope-list-column-visibility';
export const PAGE_SIZE_STORAGE_KEY = 'bioscope-list-page-size';
export const DEFAULT_PAGE_SIZE = 15;

export const COLUMN_METADATA: Array<{ id: string; header: string }> = [
    { id: 'id', header: 'internal.bioscopeList.columns.id' },
    { id: 'bioscopeStatus', header: 'internal.bioscopeList.columns.bioscopeStatus' },
    { id: 'cabinet', header: 'internal.bioscopeList.columns.cabinet' },
    { id: 'bioscopeVersion', header: 'internal.bioscopeList.columns.bioscopeVersion' },
    { id: 'version', header: 'internal.bioscopeList.columns.version' },
    { id: 'client', header: 'internal.bioscopeList.columns.client' },
    { id: 'region', header: 'internal.bioscopeList.columns.region' },
    { id: 'location', header: 'internal.bioscopeList.columns.location' },
    { id: 'fishType', header: 'internal.bioscopeList.columns.fishType' },
    { id: 'cageType', header: 'internal.bioscopeList.columns.cageType' },
    { id: 'pen', header: 'internal.bioscopeList.columns.pen' },
    { id: 'fishGroup', header: 'fishGroups:locationOverview.columnHeader' },
    { id: 'cageId', header: 'internal.bioscopeList.columns.cageId' },
    { id: 'moved', header: 'internal.bioscopeList.columns.moved' },
    { id: 'lastMeasurement', header: 'internal.bioscopeList.columns.lastMeasurement' },
    { id: 'alerts', header: 'internal.bioscopeList.columns.alerts' },
    { id: 'finClip', header: 'internal.bioscopeList.columns.finClip' },
    { id: 'winch', header: 'internal.bioscopeList.columns.winch' },
    { id: 'winchId', header: 'internal.bioscopeList.columns.winchId' },
    { id: 'testBioscope', header: 'internal.bioscopeList.columns.testBioscope' },
    { id: 'uvc', header: 'internal.bioscopeList.columns.uvc' },
    { id: 'jetpackVersion', header: 'internal.bioscopeList.columns.jetpackVersion' },
];
